export const START_FAILED = 'START_FAILED';
export const EXPIRED_TRANSACTION = 'EXPIRED_TRANSACTION';
export const ALREADY_IN_PROGRESS = 'ALREADY_IN_PROGRESS';
export const CERTIFICATE_ERROR = 'CERTIFICATE_ERROR';
export const CANCELLED = 'CANCELLED';
export const USER_CANCEL = 'USER_CANCEL';
